'use strict';

var _toConsumableArray = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/toConsumableArray");

var _asyncToGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncToGenerator");

var _regeneratorRuntime = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator");

var _createForOfIteratorHelper = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createForOfIteratorHelper");

var _classCallCheck = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _asyncIterator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/asyncIterator");

var _awaitAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/awaitAsyncGenerator");

var _wrapAsyncGenerator = require("/vercel/path0/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/wrapAsyncGenerator");

var Block = require('ipld-block');

var CID = require('cids');

var mergeOptions = require('merge-options');

var ipldDagCbor = require('ipld-dag-cbor');

var ipldDagPb = require('ipld-dag-pb');

var ipldRaw = require('ipld-raw');

var multicodec = require('multicodec');

var typical = require('typical');

var _require = require('buffer'),
    Buffer = _require.Buffer;

var _require2 = require('./util'),
    extendIterator = _require2.extendIterator;

var IPLDResolver = /*#__PURE__*/function () {
  function IPLDResolver(userOptions) {
    _classCallCheck(this, IPLDResolver);

    var options = mergeOptions(IPLDResolver.defaultOptions, userOptions);

    if (!options.blockService) {
      throw new Error('Missing blockservice');
    }

    this.bs = options.blockService; // Object with current list of active resolvers

    this.resolvers = {};

    if (typeof options.loadFormat !== 'function') {
      this.loadFormat = function (codec) {
        var codecName = multicodec.print[codec];
        throw new Error("No resolver found for codec \"".concat(codecName, "\""));
      };
    } else {
      this.loadFormat = options.loadFormat;
    } // Enable all supplied formats


    var _iterator4 = _createForOfIteratorHelper(options.formats),
        _step4;

    try {
      for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
        var format = _step4.value;
        this.addFormat(format);
      }
    } catch (err) {
      _iterator4.e(err);
    } finally {
      _iterator4.f();
    }
  }
  /**
   * Add support for an IPLD Format.
   *
   * @param {Object} format - The implementation of an IPLD Format.
   * @returns {this}
   */


  _createClass(IPLDResolver, [{
    key: "addFormat",
    value: function addFormat(format) {
      var codec = format.codec;

      if (this.resolvers[format.format]) {
        var codecName = multicodec.print[codec];
        throw new Error("Resolver already exists for codec \"".concat(codecName, "\""));
      }

      this.resolvers[codec] = format;
      return this;
    }
    /**
     * Remove support for an IPLD Format.
     *
     * @param {number} codec - The codec of the IPLD Format to remove.
     * @returns {this}
     */

  }, {
    key: "removeFormat",
    value: function removeFormat(codec) {
      if (this.resolvers[codec]) {
        delete this.resolvers[codec];
      }

      return this;
    }
    /**
     * Retrieves IPLD Nodes along the `path` that is rooted at `cid`.
     *
     * @param {CID} cid - the CID the resolving starts.
     * @param {string} path - the path that should be resolved.
     * @param {Object} [options] -  Options is an object with the following properties.
     * @param {AbortSignal} [options.signal] - A signal that can be used to abort any long-lived operations that are started as a result of this operation.
     * @returns {Iterable.<Promise.<{remainderPath: string, value}>>} - Returns an async iterator of all the IPLD Nodes that were traversed during the path resolving. Every element is an object with these fields:
     *   - `remainderPath`: the part of the path that wasn’t resolved yet.
     *   - `value`: the value where the resolved path points to. If further traversing is possible, then the value is a CID object linking to another IPLD Node. If it was possible to fully resolve the path, value is the value the path points to. So if you need the CID of the IPLD Node you’re currently at, just take the value of the previously returned IPLD Node.
     */

  }, {
    key: "resolve",
    value: function resolve(cid, path, options) {
      if (!CID.isCID(cid)) {
        throw new Error('`cid` argument must be a CID');
      }

      if (typeof path !== 'string') {
        throw new Error('`path` argument must be a string');
      }

      var generator = /*#__PURE__*/_wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var format, block, result, value;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!(cid !== null)) {
                  _context.next = 16;
                  break;
                }

                _context.next = 3;
                return _awaitAsyncGenerator(this._getFormat(cid.codec));

              case 3:
                format = _context.sent;
                _context.next = 6;
                return _awaitAsyncGenerator(this.bs.get(cid, options));

              case 6:
                block = _context.sent;
                result = format.resolver.resolve(block.data, path); // Prepare for the next iteration if there is a `remainderPath`

                path = result.remainderPath;
                value = result.value; // NOTE vmx 2018-11-29: Not all IPLD Formats return links as
                // CIDs yet. Hence try to convert old style links to CIDs

                if (Object.keys(value).length === 1 && '/' in value) {
                  try {
                    value = new CID(value['/']);
                  } catch (_error) {
                    value = null;
                  }
                }

                cid = CID.isCID(value) ? value : null;
                _context.next = 14;
                return {
                  remainderPath: path,
                  value: value
                };

              case 14:
                _context.next = 0;
                break;

              case 16:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      })).bind(this);

      return extendIterator(generator());
    }
    /**
     * Get a node by CID.
     *
     * @param {CID} cid - The CID of the IPLD Node that should be retrieved.
     * @param {Object} [options] -  Options is an object with the following properties.
     * @param {AbortSignal} [options.signal] - A signal that can be used to abort any long-lived operations that are started as a result of this operation.
     * @returns {Promise.<Object>} - Returns a Promise with the IPLD Node that correspond to the given `cid`.
     */

  }, {
    key: "get",
    value: function () {
      var _get = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(cid, options) {
        var block, format, node;
        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return this.bs.get(cid, options);

              case 2:
                block = _context2.sent;
                _context2.next = 5;
                return this._getFormat(block.cid.codec);

              case 5:
                format = _context2.sent;
                node = format.util.deserialize(block.data);
                return _context2.abrupt("return", node);

              case 8:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function get(_x, _x2) {
        return _get.apply(this, arguments);
      }

      return get;
    }()
    /**
     * Get multiple nodes back from an array of CIDs.
     *
     * @param {Iterable.<CID>} cids - The CIDs of the IPLD Nodes that should be retrieved.
     * @param {Object} [options] -  Options is an object with the following properties.
     * @param {AbortSignal} [options.signal] - A signal that can be used to abort any long-lived operations that are started as a result of this operation.
     * @returns {Iterable.<Promise.<Object>>} - Returns an async iterator with the IPLD Nodes that correspond to the given `cids`.
     */

  }, {
    key: "getMany",
    value: function getMany(cids, options) {
      if (!typical.isIterable(cids) || typeof cids === 'string' || Buffer.isBuffer(cids)) {
        throw new Error('`cids` must be an iterable of CIDs');
      }

      var generator = /*#__PURE__*/_wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _iteratorNormalCompletion, _didIteratorError, _iteratorError, _iterator, _step, _value, cid;

        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                _iteratorNormalCompletion = true;
                _didIteratorError = false;
                _context3.prev = 2;
                _iterator = _asyncIterator(cids);

              case 4:
                _context3.next = 6;
                return _awaitAsyncGenerator(_iterator.next());

              case 6:
                _step = _context3.sent;
                _iteratorNormalCompletion = _step.done;
                _context3.next = 10;
                return _awaitAsyncGenerator(_step.value);

              case 10:
                _value = _context3.sent;

                if (_iteratorNormalCompletion) {
                  _context3.next = 18;
                  break;
                }

                cid = _value;
                _context3.next = 15;
                return this.get(cid, options);

              case 15:
                _iteratorNormalCompletion = true;
                _context3.next = 4;
                break;

              case 18:
                _context3.next = 24;
                break;

              case 20:
                _context3.prev = 20;
                _context3.t0 = _context3["catch"](2);
                _didIteratorError = true;
                _iteratorError = _context3.t0;

              case 24:
                _context3.prev = 24;
                _context3.prev = 25;

                if (!(!_iteratorNormalCompletion && _iterator.return != null)) {
                  _context3.next = 29;
                  break;
                }

                _context3.next = 29;
                return _awaitAsyncGenerator(_iterator.return());

              case 29:
                _context3.prev = 29;

                if (!_didIteratorError) {
                  _context3.next = 32;
                  break;
                }

                throw _iteratorError;

              case 32:
                return _context3.finish(29);

              case 33:
                return _context3.finish(24);

              case 34:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this, [[2, 20, 24, 34], [25,, 29, 33]]);
      })).bind(this);

      return extendIterator(generator());
    }
    /**
     * Stores the given IPLD Node of a recognized IPLD Format.
     *
     * @param {Object} node - The deserialized IPLD node that should be inserted.
     * @param {number} format - The multicodec of the format that IPLD Node should be encoded in.
     * @param {Object} [userOptions] -  Options is an object with the following properties.
     * @param {number} [userOtions.hashAlg=hash algorithm of the given multicodec] - The hashing algorithm that is used to calculate the CID.
     * @param {number} [userOptions.cidVersion=1] - The CID version to use.
     * @param {boolean} [userOptions.onlyHash=false] - If true the serialized form of the IPLD Node will not be passed to the underlying block store.
     * @param {AbortSignal} [userOptions.signal] - A signal that can be used to abort any long-lived operations that are started as a result of this operation.
     * @returns {Promise.<CID>} - Returns the CID of the serialized IPLD Nodes.
     */

  }, {
    key: "put",
    value: function () {
      var _put = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(node, format, userOptions) {
        var formatImpl, defaultOptions, options, cidOptions, serialized, cid, block;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                if (!(format === undefined)) {
                  _context4.next = 2;
                  break;
                }

                throw new Error('`put` requires a format');

              case 2:
                if (!(typeof format !== 'number')) {
                  _context4.next = 4;
                  break;
                }

                throw new Error('`format` parameter must be number (multicodec)');

              case 4:
                _context4.next = 6;
                return this._getFormat(format);

              case 6:
                formatImpl = _context4.sent;
                defaultOptions = {
                  hashAlg: formatImpl.defaultHashAlg,
                  cidVersion: 1,
                  onlyHash: false
                };
                options = mergeOptions(defaultOptions, userOptions);
                cidOptions = {
                  cidVersion: options.cidVersion,
                  hashAlg: options.hashAlg,
                  onlyHash: options.onlyHash
                };
                serialized = formatImpl.util.serialize(node);
                _context4.next = 13;
                return formatImpl.util.cid(serialized, cidOptions);

              case 13:
                cid = _context4.sent;

                if (options.onlyHash) {
                  _context4.next = 18;
                  break;
                }

                block = new Block(serialized, cid);
                _context4.next = 18;
                return this.bs.put(block, options);

              case 18:
                return _context4.abrupt("return", cid);

              case 19:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function put(_x3, _x4, _x5) {
        return _put.apply(this, arguments);
      }

      return put;
    }()
    /**
     * Stores the given IPLD Nodes of a recognized IPLD Format.
     *
     * @param {Iterable.<Object>} nodes - Deserialized IPLD nodes that should be inserted.
     * @param {number} format - The multicodec of the format that IPLD Node should be encoded in.
     * @param {Object} [userOptions] -  Options are applied to any of the `nodes` and is an object with the following properties.
     * @param {number} [userOtions.hashAlg=hash algorithm of the given multicodec] - The hashing algorithm that is used to calculate the CID.
     * @param {number} [userOptions.cidVersion=1] - The CID version to use.
     * @param {boolean} [userOptions.onlyHash=false] - If true the serialized form of the IPLD Node will not be passed to the underlying block store.
     * @param {AbortSignal} [userOptions.signal] - A signal that can be used to abort any long-lived operations that are started as a result of this operation.
     * @returns {Iterable.<Promise.<CID>>} - Returns an async iterator with the CIDs of the serialized IPLD Nodes.
     */

  }, {
    key: "putMany",
    value: function putMany(nodes, format, userOptions) {
      if (!typical.isIterable(nodes) || typeof nodes === 'string' || Buffer.isBuffer(nodes)) {
        throw new Error('`nodes` must be an iterable');
      }

      if (format === undefined) {
        throw new Error('`put` requires a format');
      }

      if (typeof format !== 'number') {
        throw new Error('`format` parameter must be number (multicodec)');
      }

      var options;
      var formatImpl;

      var generator = /*#__PURE__*/_wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5() {
        var _iteratorNormalCompletion2, _didIteratorError2, _iteratorError2, _iterator2, _step2, _value2, node, defaultOptions;

        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                _iteratorNormalCompletion2 = true;
                _didIteratorError2 = false;
                _context5.prev = 2;
                _iterator2 = _asyncIterator(nodes);

              case 4:
                _context5.next = 6;
                return _awaitAsyncGenerator(_iterator2.next());

              case 6:
                _step2 = _context5.sent;
                _iteratorNormalCompletion2 = _step2.done;
                _context5.next = 10;
                return _awaitAsyncGenerator(_step2.value);

              case 10:
                _value2 = _context5.sent;

                if (_iteratorNormalCompletion2) {
                  _context5.next = 24;
                  break;
                }

                node = _value2;

                if (!(options === undefined)) {
                  _context5.next = 19;
                  break;
                }

                _context5.next = 16;
                return _awaitAsyncGenerator(this._getFormat(format));

              case 16:
                formatImpl = _context5.sent;
                defaultOptions = {
                  hashAlg: formatImpl.defaultHashAlg,
                  cidVersion: 1,
                  onlyHash: false
                };
                options = mergeOptions(defaultOptions, userOptions);

              case 19:
                _context5.next = 21;
                return this.put(node, format, options);

              case 21:
                _iteratorNormalCompletion2 = true;
                _context5.next = 4;
                break;

              case 24:
                _context5.next = 30;
                break;

              case 26:
                _context5.prev = 26;
                _context5.t0 = _context5["catch"](2);
                _didIteratorError2 = true;
                _iteratorError2 = _context5.t0;

              case 30:
                _context5.prev = 30;
                _context5.prev = 31;

                if (!(!_iteratorNormalCompletion2 && _iterator2.return != null)) {
                  _context5.next = 35;
                  break;
                }

                _context5.next = 35;
                return _awaitAsyncGenerator(_iterator2.return());

              case 35:
                _context5.prev = 35;

                if (!_didIteratorError2) {
                  _context5.next = 38;
                  break;
                }

                throw _iteratorError2;

              case 38:
                return _context5.finish(35);

              case 39:
                return _context5.finish(30);

              case 40:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this, [[2, 26, 30, 40], [31,, 35, 39]]);
      })).bind(this);

      return extendIterator(generator());
    }
    /**
     * Remove an IPLD Node by the given CID.
     *
     * @param {CID} cid - The CID of the IPLD Node that should be removed.
     * @param {Object} [options] -  Options is an object with the following properties.
     * @param {AbortSignal} [options.signal] - A signal that can be used to abort any long-lived operations that are started as a result of this operation.
     * @return {Promise.<CID>} The CID of the removed IPLD Node.
     */

  }, {
    key: "remove",
    value: function () {
      var _remove = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(cid, options) {
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                return _context6.abrupt("return", this.bs.delete(cid, options));

              case 1:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function remove(_x6, _x7) {
        return _remove.apply(this, arguments);
      }

      return remove;
    }()
    /**
     * Remove IPLD Nodes by the given CIDs.
     *
     * Throws an error if any of the Blocks can’t be removed. This operation is
     * *not* atomic, some Blocks might have already been removed.
     *
     * @param {Iterable.<CID>} cids - The CIDs of the IPLD Nodes that should be removed.
     * @param {Object} [options] -  Options is an object with the following properties.
     * @param {AbortSignal} [options.signal] - A signal that can be used to abort any long-lived operations that are started as a result of this operation.
     * @return {Iterable.<Promise.<CID>>} Returns an async iterator with the CIDs of the removed IPLD Nodes.
     */

  }, {
    key: "removeMany",
    value: function removeMany(cids, options) {
      if (!typical.isIterable(cids) || typeof cids === 'string' || Buffer.isBuffer(cids)) {
        throw new Error('`cids` must be an iterable of CIDs');
      }

      var generator = /*#__PURE__*/_wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7() {
        var _iteratorNormalCompletion3, _didIteratorError3, _iteratorError3, _iterator3, _step3, _value3, cid;

        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                _iteratorNormalCompletion3 = true;
                _didIteratorError3 = false;
                _context7.prev = 2;
                _iterator3 = _asyncIterator(cids);

              case 4:
                _context7.next = 6;
                return _awaitAsyncGenerator(_iterator3.next());

              case 6:
                _step3 = _context7.sent;
                _iteratorNormalCompletion3 = _step3.done;
                _context7.next = 10;
                return _awaitAsyncGenerator(_step3.value);

              case 10:
                _value3 = _context7.sent;

                if (_iteratorNormalCompletion3) {
                  _context7.next = 18;
                  break;
                }

                cid = _value3;
                _context7.next = 15;
                return this.remove(cid, options);

              case 15:
                _iteratorNormalCompletion3 = true;
                _context7.next = 4;
                break;

              case 18:
                _context7.next = 24;
                break;

              case 20:
                _context7.prev = 20;
                _context7.t0 = _context7["catch"](2);
                _didIteratorError3 = true;
                _iteratorError3 = _context7.t0;

              case 24:
                _context7.prev = 24;
                _context7.prev = 25;

                if (!(!_iteratorNormalCompletion3 && _iterator3.return != null)) {
                  _context7.next = 29;
                  break;
                }

                _context7.next = 29;
                return _awaitAsyncGenerator(_iterator3.return());

              case 29:
                _context7.prev = 29;

                if (!_didIteratorError3) {
                  _context7.next = 32;
                  break;
                }

                throw _iteratorError3;

              case 32:
                return _context7.finish(29);

              case 33:
                return _context7.finish(24);

              case 34:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this, [[2, 20, 24, 34], [25,, 29, 33]]);
      })).bind(this);

      return extendIterator(generator());
    }
    /**
     * Returns all the paths that can be resolved into.
     *
     * @param {Object} cid - The ID to get the paths from
     * @param {string} [offsetPath=''] - the path to start to retrieve the other paths from.
     * @param {Object} [userOptions]
     * @param {number} [userOptions.recursive=false] - whether to get the paths recursively or not. `false` resolves only the paths of the given CID.
     * @param {AbortSignal} [userOptions.signal] - A signal that can be used to abort any long-lived operations that are started as a result of this operation.
     * @returns {Iterable.<Promise.<String>>} - Returns an async iterator with paths that can be resolved into
     */

  }, {
    key: "tree",
    value: function tree(cid, offsetPath, userOptions) {
      var _this = this;

      if (typeof offsetPath === 'object') {
        userOptions = offsetPath;
        offsetPath = undefined;
      }

      offsetPath = offsetPath || '';
      var defaultOptions = {
        recursive: false
      };
      var options = mergeOptions(defaultOptions, userOptions); // If a path is a link then follow it and return its CID

      var maybeRecurse = /*#__PURE__*/function () {
        var _ref6 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(block, treePath) {
          var format, result;
          return _regeneratorRuntime.wrap(function _callee8$(_context8) {
            while (1) {
              switch (_context8.prev = _context8.next) {
                case 0:
                  _context8.next = 2;
                  return _this._getFormat(block.cid.codec);

                case 2:
                  format = _context8.sent;
                  result = format.resolver.resolve(block.data, treePath); // Something to follow recusively, hence push it into the queue

                  if (!CID.isCID(result.value)) {
                    _context8.next = 8;
                    break;
                  }

                  return _context8.abrupt("return", result.value);

                case 8:
                  return _context8.abrupt("return", null);

                case 9:
                case "end":
                  return _context8.stop();
              }
            }
          }, _callee8);
        }));

        return function maybeRecurse(_x8, _x9) {
          return _ref6.apply(this, arguments);
        };
      }();

      var generator = /*#__PURE__*/_wrapAsyncGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9() {
        var treePaths, block, queue, basePath, _queue$shift, format, paths, treePath, fullPath;

        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                // The list of paths that will get returned
                treePaths = []; // The current block, needed to call `isLink()` on every interation

                // The list of items we want to follow recursively. The items are
                // an object consisting of the CID and the currently already resolved
                // path
                queue = [{
                  cid: cid,
                  basePath: ''
                }]; // The path that was already traversed

              case 2:
                if (!(treePaths.length > 0 || queue.length > 0)) {
                  _context9.next = 28;
                  break;
                }

                if (!(treePaths.length === 0 && queue.length > 0)) {
                  _context9.next = 15;
                  break;
                }

                _queue$shift = queue.shift();
                cid = _queue$shift.cid;
                basePath = _queue$shift.basePath;
                _context9.next = 9;
                return _awaitAsyncGenerator(this._getFormat(cid.codec));

              case 9:
                format = _context9.sent;
                _context9.next = 12;
                return _awaitAsyncGenerator(this.bs.get(cid, options));

              case 12:
                block = _context9.sent;
                paths = format.resolver.tree(block.data);
                treePaths.push.apply(treePaths, _toConsumableArray(paths));

              case 15:
                treePath = treePaths.shift();
                fullPath = basePath + treePath; // Only follow links if recursion is intended

                if (!options.recursive) {
                  _context9.next = 22;
                  break;
                }

                _context9.next = 20;
                return _awaitAsyncGenerator(maybeRecurse(block, treePath));

              case 20:
                cid = _context9.sent;

                if (cid !== null) {
                  queue.push({
                    cid: cid,
                    basePath: fullPath + '/'
                  });
                }

              case 22:
                if (!(fullPath.startsWith(offsetPath) && fullPath.length > offsetPath.length)) {
                  _context9.next = 26;
                  break;
                }

                if (offsetPath.length > 0) {
                  fullPath = fullPath.slice(offsetPath.length + 1);
                }

                _context9.next = 26;
                return fullPath;

              case 26:
                _context9.next = 2;
                break;

              case 28:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      })).bind(this);

      return extendIterator(generator());
    }
    /*           */

    /* internals */

    /*           */

  }, {
    key: "_getFormat",
    value: function () {
      var _getFormat2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(codec) {
        var constantName, format;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                // TODO vmx 2019-01-24: Once all CIDs support accessing the codec code
                // instead of the name, remove this part
                if (typeof codec === 'string') {
                  constantName = codec.toUpperCase().replace(/-/g, '_');
                  codec = multicodec[constantName];
                }

                if (!this.resolvers[codec]) {
                  _context10.next = 3;
                  break;
                }

                return _context10.abrupt("return", this.resolvers[codec]);

              case 3:
                _context10.next = 5;
                return this.loadFormat(codec);

              case 5:
                format = _context10.sent;
                this.addFormat(format);
                return _context10.abrupt("return", format);

              case 8:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function _getFormat(_x10) {
        return _getFormat2.apply(this, arguments);
      }

      return _getFormat;
    }()
  }]);

  return IPLDResolver;
}();
/**
 * Default options for IPLD.
 */


IPLDResolver.defaultOptions = {
  formats: [ipldDagCbor, ipldDagPb, ipldRaw]
};
module.exports = IPLDResolver;